import React, { useState, useEffect } from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { ListDialog } from "../shared/listDialog";
import { MMRecordNoxesInvestigations } from "./mmRecordNoxesInvestigations";
import { mmRecordService } from '../../services/api/mmRecord.service';
import { nomService } from "../../services/api/nom.service";
import { utils } from "../../services/helpers/utils";
import { alertService } from '../../services/helpers/alert.service';

export const MMRecordNoxes = (props) => {

    /* Rand nou de adaugat */
    const _newRow = {
        idNoxa: "",
        idFisa: props.idFisa ?? 0
    }
    /* Lista de noxe a Fisei */
    const [list, setList] = useState([]);
    /* Lista de noxe care au risc */ 
    const [allNoxes, setAllNoxes] = useState([]);
    /* Obiecte de tip key - value  relative la lista si dropdownuri */
    const [defaults, setDefaults] = useState([]);
    /* Dropdown-ul de noxe */
    const [dropdown, setDropdown] = useState([]);
    /* Rand now */
    const [newRow, setNewRow] = useState(_newRow);
    const [showDialog, setShowDialog] = useState(false);
    const [clickedIndex, setClickedIndex] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");

    const rol = sessionStorage.getItem("rol");

    // Retrieve Lista de noxe a Fisei
    useEffect(() => {
        if (props && props.idFisa) {
            mmRecordService.getNoxes({ recordId: props.idFisa })
                .then(response => {
                    if (response) {
                        updateLists(response)
                    }
                });

        }
    }, [props.refresh]);

    //Retrieve Lista de noxe care au risc si dropdown-ul de noxe
    useEffect(() => {

        mmRecordService.getRiskyNoxes().then(response => {
            if (response) {
                setAllNoxes(response);
            }
        });

        nomService.getNoxes()
            .then(response => {
                if (response) {
                    setDropdown(response);
                }
            });
    }, []);
    // Lista de investigatii

    // Creez lista de obiecte de tip key/value relativa la dropdown si lista de noxe
    useEffect(() => {
        // Bug la stergere nu se actualiza si lista de default
        if (list.length == 0) {
            setDefaults([]);
            return;
        }

        // Daca lista de noxe si dropdown-ul sunt populare
        // Creez lista de obiecte de tip key/value relativa la dropdown si lista de noxe
        if (list.length > 0 && dropdown.length > 0) {
            var d = [];
            for (var item in list) {
                var el = utils.findObjectById(dropdown, list[item].idNoxa)

                if (el) {
                    d.push(el);
                }
               
            }
            setDefaults(d);
        }

    }, [list, dropdown]);

    const handleAdd = () => {
        if (!props.idLocatie) {
            alertService.error("Selectati locatia!");
            return;
        }
        const updatedList = [...list, newRow];
        updateLists(updatedList)
        setNewRow( _newRow);
    };

    const handleChange = (event, index, field) => {
        const newList = [...list];
        var v = event.target.value;
        newList[index][field] = v.id;
        updateLists(newList)
        setSearchTerm("");
    };


    const handleDelete = (index) => {
        alertService.confirm("Atentie", "Esti sigur ca vrei sa stergi aceasta noxa?"
            , () => {
                const newList = [...list];
                newList.splice(index, 1);
                updateLists(newList)
            }
            , () => { return; }
        );
        
        
    };

    const updateLists = ( list) => {
        setList(list);
        props.setNoxe(list);
        if (props.setIsModified) {
            props.setIsModified(true);
        }
        calculateRisc();
    }

    const calculateRisc = () => {
        let risk = 0;
        for (var j = 0; j < list.length; j++) {
            for (var i = 0; i < allNoxes.length; i++) {
                if (list[j].idNoxa == allNoxes[i].id && allNoxes[i].cuRisc > risk) {
                    risk = allNoxes[i].cuRisc;
                }
            }
        }
        // Daca am lista de noxe cu risc incarcat doar atunci fac update 
        if (allNoxes.length > 0) {
            props.updateRisc(risk);
        }
    }

    const handleDialog = () => {
        setShowDialog(!showDialog);
    }

    const handleClick = (item) => {
        setClickedIndex(item);
        setShowDialog(true);
    }

    const handleReturn = (item) => {
        let newList = [...list];
        newList[clickedIndex].idNoxa = dropdown[item].id;
        updateLists(newList);
    }

    const handleFilterChange = (e) => {
        setSearchTerm(e.filter.value);
    };


    const filtred = searchTerm
        ? dropdown.filter((item) =>
            item.text.toLowerCase().includes(searchTerm.toLowerCase())
        )
        : dropdown;


    return (
        <>
            <fieldset name="noxe">
                <legend className="pt20 pb5">Noxe <span className="red">*</span></legend>
                <table className="tbl tbladd mt5" name="lista_noxe" width="100%">
                    <thead>
                        <tr>
                            <th>Noxe</th>
                            {props.finalizare != 1 && rol != 2 && <th width="50">Editeaza</th>}
                            {props.finalizare != 1 && rol !=2 && <th width="50">Sterge</th>}
                        </tr>
                    </thead>
                    <tbody>
                        {list.map((item, index) => (
                            <tr key={index}>
                                <td>
                                    <DropDownList className="w750 fl"
                                        name="idNoxa"
                                        data={filtred}
                                        filterable
                                        onFilterChange={handleFilterChange}
                                        textField="text"
                                        dataItemKey="id"
                                        value={defaults[index]}
                                        disabled={props.finalizare == 1 || rol == 2}
                                        onChange={ (event) => handleChange(event, index, "idNoxa") }

                                    />
                                </td>
                                {props.finalizare != 1 && rol!=2 &&
                                    <td className="center" name="noxe_edit" onClick={() => handleClick(index)}   >
                                        <span className="icon modifica center"></span>
                                    </td>
                                }
                                {props.finalizare != 1 && rol!=2 &&
                                    <td className="center" name="noxe_del" onClick={handleDelete}>
                                        <span className="icon sterge center"></span>
                                    </td>
                                }
                            </tr>
                        ))}
                    </tbody>
                </table>

                {!props.finalizare && rol != 2 &&(
                    <button name="adauga_noxe" className="btn mt10" onClick={handleAdd}>Adauga noxe</button>
                )}
                
            </fieldset>

            {
                showDialog && <ListDialog title="Noxe"
                    data={dropdown}
                    handleDialog={handleDialog}
                    handleReturn={handleReturn} />
            }

            <MMRecordNoxesInvestigations
                noxe={list}
                idFisa={props.idFisa}
                tipFisa={props.tipFisa}
                financiar={props.financiar}
                finalizare={props.finalizare }
                setInvestigatiiNoxe={props.setInvestigatiiNoxe}
                refresh={props.refresh}
            />
        
        </>
    );
}